export default __webpack_public_path__ + "static/media/center1.818e745b.jpg";